export default "__VITE_ASSET__541eadbc__"